import { fr } from 'date-fns/locale'
import { createContext, useState, useEffect } from "react";
import { startOfMonth } from 'date-fns'
import axios from "axios";

export const version = 'V.0.5'
export const dateVersion = '03/2025'

export const dateOptions = { locale: fr, timeZone: 'Europe/Berlin' }

export const ROLES = {
  ENTRAINEUR: 1,
  ADMIN: 2,
};

export const FILTER_VALUES = {
  all: -1,
  unpaids: 1,
  partials: 2,
  refunds: 3,
  reviews: 4,
}

const dataApplicationsContext = createContext({});

export const AppDataProvider = ({ children }) => {
  const [auth, setAuth] = useState([]);
  const [checkedImportFEF, setCheckedImportFEF] = useState([]); 
  const [edittingUser, setEdittingUser] = useState(null);
  const [filterOnglet, setFilterOnglet] = useState(FILTER_VALUES['all']);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAppUser, setIsAppUser] = useState(false);
  const [isComingFromRecap, setIsComingFromRecap] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openOffrePeriode, setOpenOffrePeriode] = useState(false);
  const [openModalNewUser, setOpenModalNewUser] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  return (
    <dataApplicationsContext.Provider value={{
      auth, setAuth, isAdmin, setIsAdmin, isConnected, setIsConnected, openModal, setOpenModal, isAppUser, setIsAppUser,
      openSidebar, setOpenSidebar, openOffrePeriode, setOpenOffrePeriode, checkedImportFEF, setCheckedImportFEF,
      windowWidth, setWindowWidth, isMenuActive, setIsMenuActive, openModalNewUser, setOpenModalNewUser,
      edittingUser, setEdittingUser, isComingFromRecap, setIsComingFromRecap, selectedSeason, setSelectedSeason,
      filterOnglet, setFilterOnglet, selectedGroup, setSelectedGroup
    }}>
      {children}
    </dataApplicationsContext.Provider>
  )
}

export default dataApplicationsContext;
